(function () {
  function initCategoryCorner(root) {
    if (!root || root.dataset.categoryCornerReady === 'true') return;

    var track = root.querySelector('[data-category-corner-track]');
    var prevBtn = root.querySelector('[data-category-corner-prev]');
    var nextBtn = root.querySelector('[data-category-corner-next]');
    if (!track || !prevBtn || !nextBtn) return;

    root.dataset.categoryCornerReady = 'true';

    var originalCards = Array.prototype.slice.call(track.children);
    var loopEnabled = originalCards.length > 1 && root.dataset.designMode !== 'true';
    var setWidth = 0;

    function cloneSet(hidden) {
      var frag = document.createDocumentFragment();
      originalCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, [tabindex]').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        frag.appendChild(clone);
      });
      return frag;
    }

    if (loopEnabled) {
      track.insertBefore(cloneSet(), track.firstChild);
      track.appendChild(cloneSet());
    }

    function scrollAmount() {
      var card = track.querySelector('.category-corner__card');
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 12;
      return card.getBoundingClientRect().width + gap;
    }

    function measureSetWidth() {
      if (!loopEnabled || !originalCards[0]) return 0;
      var trackRect = track.getBoundingClientRect();
      var firstRect = originalCards[0].getBoundingClientRect();
      return track.scrollLeft + (firstRect.left - trackRect.left);
    }

    function jumpTo(left) {
      var snap = track.style.scrollSnapType;
      var behavior = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left;
      requestAnimationFrame(function () {
        track.style.scrollSnapType = snap;
        track.style.scrollBehavior = behavior;
      });
    }

    function handleLoopScroll() {
      if (!loopEnabled || setWidth <= 0) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft <= 0) {
        jumpTo(track.scrollLeft + setWidth);
      } else if (track.scrollLeft >= maxScroll - 1) {
        jumpTo(track.scrollLeft - setWidth);
      }
    }

    function updateNav() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      var canScroll = maxScroll > 0;
      prevBtn.hidden = !canScroll;
      nextBtn.hidden = !canScroll;
      if (!canScroll || loopEnabled) return;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      updateNav();
      handleLoopScroll();
    }, { passive: true });

    window.addEventListener('resize', function () {
      setWidth = measureSetWidth();
      updateNav();
    });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        setWidth = measureSetWidth();
        updateNav();
      }).observe(track);
    }

    if (loopEnabled) {
      requestAnimationFrame(function () {
        setWidth = measureSetWidth();
        jumpTo(setWidth);
        updateNav();
      });
    } else {
      updateNav();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-category-corner]').forEach(initCategoryCorner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-category-corner]');
    if (root) {
      root.dataset.categoryCornerReady = 'false';
      initCategoryCorner(root);
    }
  });
})();
